import React from 'react';
import { withAuth } from '../../auth/AuthContext';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import zermattLogo from '../../assets/img/zermatt-logo.png';

class Home extends React.Component {
  render() {
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <img src={zermattLogo} />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withAuth(Home);



// WEBPACK FOOTER //
// ./src/views/Pages/Home.jsx